import React, { useContext, useState } from "react";
import { BotStatus } from "@shared/types";
import { BotsBulkActionsContext } from "@shared/features/bots/BotsBulkActionsProvider";
import Dropdown from "common/Dropdown/Dropdown";

interface SelectAllBotsDropdownProps {
  trigger: React.JSX.Element;
}

const SelectAllBotsDropdown = ({ trigger }: SelectAllBotsDropdownProps) => {
  const {
    selectedBotStatus,
    onSelectUnselectAllPress,
    setBotStatusSelectOpen,
    botStatusSelectOpen,
    isAllBotsWithStatusSelected,
    isStatusDropdownEnabled,
    allowBulkChangeStatus,
  } = useContext(BotsBulkActionsContext)!;
  const [localIsOpen, setLocalIsOpen] = useState(false);

  const menuItems = [
    {
      key: "all",
      label: "All Bots",
      onClick: () => onSelectUnselectAllPress("all"),
    },
  ];
  if (
    selectedBotStatus !== BotStatus.INACTIVE &&
    !isAllBotsWithStatusSelected &&
    allowBulkChangeStatus
  ) {
    menuItems.push({
      key: "active",
      label: "Active Bots",
      onClick: () => onSelectUnselectAllPress(true),
    });
  }
  if (
    selectedBotStatus !== BotStatus.ACTIVE &&
    !isAllBotsWithStatusSelected &&
    allowBulkChangeStatus
  ) {
    menuItems.push({
      key: "Inactive",
      label: "Inactive Bots",
      onClick: () => onSelectUnselectAllPress(false),
    });
  }

  return (
    <Dropdown
      title="Select All"
      menu={{ items: menuItems }}
      onOpenChange={(open) => {
        setBotStatusSelectOpen(open);
        setLocalIsOpen(open);
      }}
      open={botStatusSelectOpen && localIsOpen}
      trigger={isStatusDropdownEnabled ? ["click"] : []}
    >
      {trigger}
    </Dropdown>
  );
};

export default SelectAllBotsDropdown;
